import { Objective } from "@/types/objective/objective-type";
import ObjectiveProgress from "./components/objective-progress/objective-progress";
import { ObjectiveSocialMedia } from "./objective-social-media-type";
import ObjectivePost from "./components/objective-post/objective-post";
import { MissionTypeObjective } from "@/components/missions-render-v1/missions-render-types";
import ObjectiveContest from "../objective-contest/objective-contest";

const COMPONENT_OBJECTIVE_POST = {
	GET_LIKES: ObjectiveProgress,
	GET_COMMENTS: ObjectiveProgress,
	GET_SHARES: ObjectiveProgress,
	GET_VIEWS: ObjectiveProgress,
	MAKE_POST: ObjectivePost,
	CONNECT: ObjectiveProgress,
	CONTEST: ObjectiveContest
} as const;

const MissionSocialMedia: React.FC<ObjectiveSocialMedia> = ({
	mission,
	objective,
	participant,
	campaign,
	getProgress,
	isExpiredMission,
	isComingSoon,
	isCompleted,
	completedRequirements,
	position = 1,
	loadingProgress,
	setWinners,
	disabledMission
}) => {
	const { type, children } = objective;
	const typeObjective = type?.split(':')[0] as MissionTypeObjective;
	const ComponentObjective = COMPONENT_OBJECTIVE_POST[typeObjective as keyof typeof COMPONENT_OBJECTIVE_POST] ?? null;

	if (!ComponentObjective) {
		return null;
	}

	return (
		<>
			<ComponentObjective 
				objective={objective}
				campaignId={campaign?.id}
				missionId={mission.id}
				participant={participant}
				getProgress={getProgress}
				isExpiredMission={isExpiredMission}
				isComingSoon={isComingSoon}
				completedRequirements={completedRequirements}
				isCompleted={isCompleted}
				position={position}
				loadingProgress={loadingProgress}
				setWinners={setWinners}
				disabledMission={disabledMission}
			/>
			{children?.length > 0 && children.map((child: Objective, index: number) => (
				<MissionSocialMedia
					key={child.id}
					mission={mission}
					objective={child}
					participant={participant}
					campaign={campaign}
					getProgress={getProgress}
					isExpiredMission={isExpiredMission}
					isComingSoon={isComingSoon}
					isCompleted={isCompleted}
					completedRequirements={completedRequirements}
					position={typeObjective === 'CONNECT' ? index + 1: position + index + 1 }
					loadingProgress={loadingProgress}
					setWinners={setWinners}
					disabledMission={disabledMission}
				/>
			))}
		</>
	)
}

export default MissionSocialMedia;
